import { Component, Input, OnInit } from '@angular/core';
import { StatoFascicoloConfiguration } from '../../../../core/configuration/stato-entita-configuration';
import { ModalNotifyService } from '../../../../core/services/modal-notify.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ViewManagerService } from '../../../../core/services/view-manager-service';
import { Note } from '../../../models/note';
import { ProfiloUtente } from '../../../models/profilo-utente';

@Component({
    selector: '[rifiuto_component]',
  templateUrl: 'rifiuto.component.html'
})

export class RifiutoComponent implements OnInit {

  @Input()
  fascicoloId: string;

  @Input()
  fascicolo;

  @Input()
  oggettoRifiuto: string;

  @Input()
  urlRifiuto: string;

  @Input()
  smistamento: boolean;

  @Input()
  routingSmistamento: string;

  @Input()
  routingCompetenza: string;

  @Input()
  userProfile: ProfiloUtente;

  @Input()
  legali: boolean;

  note: Note = new Note();
  showRifiuto: boolean = true;

  constructor(
    private operationsService: OperationsService,
    private modalNotifyService: ModalNotifyService,
    protected viewManager: ViewManagerService) { }

  ngOnInit() {
    if (this. fascicolo) {
        console.log(this.fascicolo);
        let indicePassaggioAssegnazioneLegale = this.fascicolo.registroFascicolo.passaggiDiStato.findIndex(e => e.statoSuccessivo.id === StatoFascicoloConfiguration.IN_ASSEGNAZIONE_LEGALE);
        console.log(indicePassaggioAssegnazioneLegale);
        if (indicePassaggioAssegnazioneLegale <= 0) {
          for (let passaggio of this.fascicolo.registroFascicolo.passaggiDiStato) {
             if ((passaggio.statoSuccessivo.id === StatoFascicoloConfiguration.IN_ASSEGNAZIONE) && (passaggio.statoPrecedente.id === StatoFascicoloConfiguration.DA_COMPLETARE)) {
                this.showRifiuto = false;
             }
          }
        }
      }
  }
  rifiutaCallback(motivoRifiuto: string) {
    this.note.note = motivoRifiuto;
    this.operationsService.rifiutoFaseSmistamento(this.urlRifiuto, this.fascicolo.id, this.note).subscribe(response => this.notifyRifiutoCallback(response));
  }

  notifyRifiutoCallback(response) {
    this.viewManager._refreshAttivitaCompletare.next({param: response, timeOut: false});
    if (this.userProfile.smistatore && this.smistamento) {
      this.modalNotifyService.notifySuccessCallback(response, this.routingSmistamento, this.fascicolo.id);
    } else if (this.userProfile.assegnatore && !this.smistamento && !this.legali) {
      this.modalNotifyService.notifySuccessCallback(response, this.routingCompetenza, this.fascicolo.id);
    } else {
      this.modalNotifyService.notifySuccessCallback(response, '', null);
    }
  }
}
